import React, { useContext, useState } from "react";
import plus from "../icons/plus.svg";
import { Link } from "react-router-dom";
import AddedMed from "./AddedMed";
import medContext from "../context/medContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AddMedications() {
  const [medicine, setMedicine] = useState("");
  const context = useContext(medContext);
  const { med, setMed } = context;
  function capitalizeFirstLetter(medicine) {
    return medicine.charAt(0).toUpperCase() + medicine.slice(1).toLowerCase();
  }
  const handleOnChange = (e) => {
    setMedicine(e.target.value);
  };
  const handleOnClick = () => {
    const regex = /^[a-zA-Z0-9].*[a-zA-Z0-9]$/;
    if (regex.test(medicine.trim()) && !med.includes(capitalizeFirstLetter(medicine.trim())) && medicine.trim().length !== 0) {
      setMed([...med, capitalizeFirstLetter(medicine.trim())]);
    }else{
      if(!regex.test(medicine.trim())) toast.error("Enter a valid drug name!");
      else toast.error("Drug is already present!");
    }
    setMedicine("");
  };
  const handleClear = () => {
    setMed([]);
    toast.success("All drugs removed successfully!");
  }
  return (
    <div className="flex-center medications">
      <h1 className="primary-color" style={{ fontSize: "18px" }}>
        De-Med
      </h1>
      <p style={{ fontSize: "14px" }}>(Deprescribing Medications)</p>
      <p className="primary-color" style={{ fontSize: "18px" }}>
        Empowering Safe and Appropriate Medication Use in the Elderly
      </p>
      <div className="flex-center">
        <textarea
          name="addmed"
          id="addmed"
          className="flex-center"
          value={medicine}
          onChange={handleOnChange}
          cols="50"
          rows="1"
        ></textarea>
        <img
          className="plus-icon"
          src={plus}
          alt="add"
          width="40px"
          height="40px"
          onClick={handleOnClick}
        />
      </div>
      {med.length===0 && <p className="message primary-color">(Add the drug to check)</p>}
      <div className="flex-between">
        <Link to="/result">
          <button className="btn btn-small" disabled={med.length===0}>CHECK</button>
        </Link>
        <button className="btn btn-small" onClick={handleClear} disabled={med.length===0}>RESET</button>
      </div>
      {med.length>0 && <p className="message">(Click on added drug to remove it)</p>}
      <ToastContainer position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <AddedMed />
    </div>
  );
}

export default AddMedications;
